import { render } from "./MainTimeline.vue?vue&type=template&id=39cc2512&scoped=true"
import script from "./MainTimeline.vue?vue&type=script&lang=js"
export * from "./MainTimeline.vue?vue&type=script&lang=js"

import "./MainTimeline.vue?vue&type=style&index=0&id=39cc2512&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39cc2512"]])

export default __exports__